import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
let HeaderTable = class HeaderTable extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "label", void 0);
  }
};
__decorate([Prop({
  default: ""
})], HeaderTable.prototype, "label", void 0);
HeaderTable = __decorate([Options({
  components: {}
})], HeaderTable);
export default HeaderTable;